import { t } from 'i18next';
import { today } from '../../components/BtDate';
import i18n from '../../i18n/config';
/* eslint-disable */

export const validateRegno = (regno: string) => {
  const t = i18n.t;

  if ((regno && regno.trim() === '') || !regno) {
    return t('validate.regnoMissing');
  }
  if (regno && regno.length < 2) {
    return t('validate.regnoInvalid');
  }
  if (regno && regno.length > 7) {
    return t('validate.regnoInvalid');
  }
  return null;
};

export function validateMobile(mobile: string) {
  const appId = process.env.REACT_APP_APPLICATION_ID!;
  if (!mobile) {
    return t('validate.mobileInvalid');
  }

  const normalized = mobile.replace(/\s+/g, '');
  const validFormat = /^\+\d{6,15}$/;

  if (!validFormat.test(normalized)) {
    return t('validate.mobileInvalid');
  }

  if (appId === 'gat-transport-se' && !normalized.startsWith('+46')) {
    return t('validate.mobileSweden');
  }

  if (appId === 'gat-transport-dk' && !normalized.startsWith('+45')) {
    return t('validate.mobileDenmark');
  }

  return null;
}

export function validateBookingId(id: string) {
  if (!id) {
    return t('validate.idMissing');
  }

  return null;
}

export const validateSocialNumber = (socialNumber: string) => {
  const onlyNumberPattern = /^[0-9\-]+$/;
  if (socialNumber && !socialNumber.match(onlyNumberPattern)) {
    return t('validate.govIdInvalid');
  }

  if ((socialNumber && socialNumber.trim() === '') || !socialNumber) {
    return t('validate.govIdInvalid');
  }
  if (socialNumber.length < 10) {
    return t('validate.govIdInvalid');
  }
  if (socialNumber.length > 13) {
    return t('validate.govIdInvalid');
  }
  return null;
};

export const validateGovNumber = (govNumber: string) => {
  const onlyNumberPattern = /^[0-9\-]+$/;
  const withHyphen = /(\d{6}\-\d{4})/;

  if (!govNumber.trim().match(onlyNumberPattern)) {
    return t('validate.govNoInvalid');
  }

  if ((govNumber && govNumber.trim() === '') || !govNumber) {
    return t('validate.govNoInvalid');
  }

  if (govNumber.trim().length < 10 || govNumber.trim().length > 12) {
    return t('validate.govNoInvalid');
  }

  return null;
};

export const validateWeight = (weight: string) => {
  const onlyNumberPattern = /^\s*|[1-9][0-9]*/;

  if (!weight.trim().match(onlyNumberPattern)) {
    return t('validate.weightInvalid');
  }

  if (parseInt(weight) > 5250) {
    return t('validate.weightMaxInvalid');
  }

  if ((weight && weight.trim() === '') || !weight) {
    return t('validate.weightMissing');
  }

  return null;
};

export const validateDate = (date: string) => {
  const withHyphen = /(\d{4}\-\d{2}\-\d{2})/;

  if (!date && !date.trim().match(withHyphen)) {
    return t('validate.dateMissing');
  }

  if ((date && date.trim() === '') || !date) {
    return t('validate.dateMissing');
  }

  if (date === today()) {
    return t('validate.dateInvalid');
  }

  if (date.replaceAll('-', '').valueOf() < today().replaceAll('-', '').valueOf()) {
    return t('validate.dateInPast');
  }

  return null;
};

export const validateLocation = (address: string, lat: string, lng: string) => {
  const onlyNumberPattern = /^\s*|[1-9][0-9]*/;

  /*
        if (!location.match(onlyNumberPattern)) {
            return t('validate.locationInvalid');
        }
    */
  if (!address) {
    return t('validate.locationMissing');
  }

  if (/\d/.test(address) === false) {
    return t('validate.streetNumberMissing');
  }

  if (/\,/.test(address) === false) {
    return t('validate.streetNumberMissing');
  }

  if (!lat && !lng) {
    return t('validate.locationInvalid');
  }

  return null;
};

export const validateEmail = (email: string) => {
  if (/\./.test(email) === false) {
    return t('validate.invalidEmail');
  }

  if (/\@/.test(email) === false) {
    return t('validate.invalidEmail');
  }

  if (!email) {
    return t('validate.invalidEmail');
  }

  return null;
};

export const validateTerms = (value: boolean) => {
  if (!value) {
    return t('validate.invalidTerms');
  }

  return null;
};

export const validateFirstName = (value: string) => {
  if (value.trim().length === 0) {
    return t('validate.firstNameMissing');
  }

  return null;
};

export const validateLastName = (value: string) => {
  if (value.trim().length === 0) {
    return t('validate.lastNameMissing');
  }

  return null;
};
